'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');

var SIZE_LARGE = 'large';
var SIZE_SMALL = 'small';
var PageHeaderPrimary = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.size, size = _b === void 0 ? SIZE_LARGE : _b, title = _a.title;
    return (jsxRuntime.jsxs("header", tslib.__assign({ "data-testid": "page-header-primary", className: "".concat(className ? " ".concat(className) : '') }, { children: [children && children, size === SIZE_SMALL ? (jsxRuntime.jsx("h2", tslib.__assign({ className: "text-uppercase exclude-global display-1 h2" }, { children: title }))) : (jsxRuntime.jsx("h1", tslib.__assign({ className: "text-uppercase exclude-global display-1 h1" }, { children: title })))] })));
};

exports.PageHeaderPrimary = PageHeaderPrimary;
//# sourceMappingURL=PageHeaderPrimary.js.map
